<template>
  <div class="body">
    <el-container>
      <UsersAside @toggle="toggle($event)" />
      <el-main>
        <el-card>
          <div slot="header" class="clearfix">
            <span> الوظائف والصلاحيات</span>
            <el-button
              v-if="accessLinks('add_role')"
              style="float: left"
              @click="showAddModal = true"
              type="success"
              >اضافة وظيفه</el-button
            >
          </div>
          <el-table :data="usersList" class="jobs">
            <el-table-column label="#" width="50">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="الوظيفه" prop="name"></el-table-column>
            <el-table-column
              label="الاجراء"
              width="80"
              v-if="accessLinks('edit_role')"
            >
              <template slot-scope="scope">
                <el-button
                  @click="showScope(scope)"
                  size="mini"
                  type="warning"
                  title="عرض"
                  style="padding: 5px 11px"
                >
                  <i
                    style="color: #fff; font-size: 18px"
                    class="el-icon-view"
                  ></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-main>
      <div v-if="showAddModal == true" class="dialog">
        <div class="bodySec">
          <p @click="showAddModal = false">
            <span><i class="far fa-times-circle"></i></span> اغلاق
          </p>
        </div>
        <div class="content">
          <h3>اضافة وظيفه</h3>
          <el-form>
            <el-row :gutter="10">
              <el-col :md="12">
                <el-form-item label="اسم الوظيفه">
                  <el-input v-model="addJobForm.name" />
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="نسخ صلاحيه">
                  <el-select v-model="RoleClone" @change="cloneRole">
                    <el-option
                      v-for="(role, index) in usersList"
                      :key="index"
                      :label="role.name"
                      :value="role.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <p>اختيار الصلاحيات</p>
            <el-row
              v-for="permission in permission"
              :key="permission.name"
              :gutter="10"
            >
              <el-col :md="24">
                <h4>{{ permission.description }}</h4>
              </el-col>
              <el-checkbox-group
                v-model="addJobForm.permissions"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                  v-for="child in permission.childern"
                  :label="child.id"
                  :key="child.name"
                  >{{ child.display_name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-row>
          </el-form>
          <el-button
            @click="addRoles"
            class="mt-3 btn-green1 btn-save"
            type="success"
            >حفظ</el-button
          >
          <el-button
            type="danger"
            @click="showAddModal = false"
            class="exit mr-2"
            >الغاء</el-button
          >
        </div>
      </div>
      <div v-if="showscopeModal == true" class="dialog">
        <div class="bodySec">
          <p @click="showscopeModal = false">
            <span><i class="far fa-times-circle"></i></span> اغلاق
          </p>
        </div>
        <div class="content">
          <h4>{{ selectedJob.name }}</h4>
          <el-form>
            <h5>تعديل الصلاحيات</h5>
            <el-row
              v-for="permission in permission"
              :key="permission.name"
              :gutter="10"
            >
              <el-col :md="24">
                {{ permission.description }}
              </el-col>
              <el-checkbox-group
                v-model="selectedJob.permissions"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                  v-for="child in permission.childern"
                  :label="child.id"
                  :key="child.name"
                  >{{ child.display_name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-row>
          </el-form>
          <el-button
            @click="updateRole"
            class="mt-3 btn-green1 btn-save"
            type="success"
            >حفظ</el-button
          >
          <el-button
            type="danger"
            @click="showscopeModal = false"
            class="exit mr-2"
            >الغاء</el-button
          >
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import UsersAside from "@/components/UsersAside.vue";
import axiosApi from "@/plugins/axios.js";
export default {
  components: { UsersAside },
  data() {
    return {
      showAddModal: false,
      activeSide: true,
      usersList: [],
      addJobForm: {
        name: "",
        permissions: [],
      },
      RoleClone: "",
      permission: [],
      showscopeModal: false,
      selectedJob: null,
    };
  },
  methods: {
    getUsers() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .get("roles")
        .then((res) => {
          this.usersList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
    toggle(active) {
      this.activeSide = active;
    },
    addRoleList(item, e) {
      console.log(item);
      console.log(e);
      if (e == true) {
        this.addJobForm.permissions.push(item.id);
      } else {
        let index = this.addJobForm.permissions.indexOf(item);
        this.addJobForm.permissions.splice(index, 1);
      }
    },
    cloneRole() {
      let user = this.usersList.find((user) => {
        return user.id == this.RoleClone;
      });
      this.addJobForm.permissions = [];
      this.addJobForm.permissions = user.permissions;
    },
    addRoles() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .post("roles", this.addJobForm)
        .then((res) => {
          this.showAddModal = false;
          this.usersList = res.data.data;
          this.addJobForm = {
            name: "",
            permissions: [],
          };
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
    showScope(scope) {
      this.showscopeModal = true;
      this.selectedJob = scope.row;
      for (let x = 0; x < this.permission.length; x++) {
        for (let z = 0; z < this.permission[x].childern.length; z++) {
          this.permission[x].childern[z].checked = false;
        }
      }
      for (let i = 0; i < this.selectedJob.permissions.length; i++) {
        for (let x = 0; x < this.permission.length; x++) {
          for (let z = 0; z < this.permission[x].childern.length; z++) {
            if (
              this.selectedJob.permissions[i] ==
              this.permission[x].childern[z].id
            ) {
              this.permission[x].childern[z].checked = true;
            }
          }
        }
      }
    },
    handleCheckedCitiesChange(value) {
      console.log("value", value);
    },
    updateRole() {
      console.log("form Update", this.selectedJob);
      const loading = this.$loading({
        lock: true,
        text: "جاري تعديل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .put(`roles/${this.selectedJob.id}`, this.selectedJob)
        .then((res) => {
          this.showscopeModal = false;
          this.getUsers();
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
  mounted() {
    this.getUsers();
    axiosApi.get("permission").then((resp) => {
      this.permission = resp.data.data;
      console.log("permission", resp);
      this.permission.map((item) => {
        item.childern.map((ele) => {
          ele["checked"] = false;
        });
      });
    });
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.dialog .content {
  width: 500px;
  max-height: 86vh;
  overflow-y: auto;
}
.dialog .content::after {
  display: none !important;
}
.dialog .content h3,
.dialog .content h4,
.dialog .content h5,
.dialog .content p {
  margin: 0;
}
.btn-save {
  width: 80%;
}
.dialog .bodySec {
  margin-top: 3vh;
}
.el-checkbox-group {
  width: 100%;
}
.el-checkbox {
  width: 50%;
  margin-right: 0;
}
tr.el-table__row {
  background-color: #f6f6f6;
}
.el-table td,
.el-table th.is-leaf {
  border-color: #fff;
}
.el-table th,
.el-table tr {
  background-color: #eaeaea;
}
</style>

<style lang="scss">
.jobs {
  .el-table__header-wrapper {
    th {
      border-color: #fff;
      background-color: #e6e6e6;
      border-bottom: 5px solid #fff !important;
    }
  }
  .el-table__body-wrapper {
    td {
      border-color: #fff;
      background-color: #f6f6f6;
    }
  }
}
</style>
